import React from 'react';
import styled, { css } from 'styled-components';
import { useI18n } from '../i18n/index';
import { theme } from '../styles/theme';
import { fadeInUp, withMotion } from '../styles/animations';

const InfoPanel = () => {
  const { t } = useI18n();

  return (
    <Panel aria-label={t('info.title')}>
      <Row>
        <Block>
          <BlockTitle>{t('info.howItWorks')}</BlockTitle>
          <BlockBody>
            <p>{t('info.description')}</p>
            <Formula>
              <code>{t('info.formula')}</code>
            </Formula>
            <p>{t('form.helperProfile')}</p>
          </BlockBody>
        </Block>

        <SafetyBlock>
          <SafetyIcon aria-hidden="true">⚠</SafetyIcon>
          <SafetyContent>
            <SafetyTitle>{t('info.safetyTitle')}</SafetyTitle>
            <SafetyText>{t('info.safetyText')}</SafetyText>
          </SafetyContent>
        </SafetyBlock>
      </Row>
    </Panel>
  );
};

const Panel = styled.section`
  background: ${theme.colors.surfaceElevated};
  border: 1px solid ${theme.colors.borderStrong};
  border-radius: ${theme.radius.xl};
  padding: ${theme.spacing.xl};

  ${withMotion(css`
    animation: ${fadeInUp} 0.5s ease both;
    animation-delay: 0.2s;
  `)}

  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: ${theme.spacing.lg} ${theme.spacing.md};
    border-radius: ${theme.radius.lg};
  }
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${theme.spacing.xl};

  @media (max-width: ${theme.breakpoints.tablet}) {
    grid-template-columns: 1fr;
    gap: ${theme.spacing.lg};
  }
`;

const Block = styled.div``;

const BlockTitle = styled.h2`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: ${theme.colors.textMuted};
  margin-bottom: ${theme.spacing.md};
`;

const BlockBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.sm};

  p {
    font-size: 13px;
    color: ${theme.colors.textSecondary};
    line-height: 1.65;
  }
`;

const Formula = styled.div`
  background: ${theme.colors.backgroundPrimary};
  border: 1px solid ${theme.colors.borderSoft};
  border-radius: ${theme.radius.md};
  padding: ${theme.spacing.sm} ${theme.spacing.md};

  code {
    font-family: ${theme.typography.fontMono};
    font-size: 12px;
    color: ${theme.colors.skyBlueLight};
    word-break: break-word;
  }
`;

const SafetyBlock = styled.div`
  display: flex;
  gap: ${theme.spacing.md};
  background: rgba(245,158,11,0.05);
  border: 1px solid rgba(245,158,11,0.18);
  border-radius: ${theme.radius.lg};
  padding: ${theme.spacing.lg};
  align-items: flex-start;
`;

const SafetyIcon = styled.span`
  font-size: 18px;
  flex-shrink: 0;
  line-height: 1.4;
  color: ${theme.colors.warningAmber};
`;

const SafetyContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.xs};
`;

const SafetyTitle = styled.h3`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  color: ${theme.colors.warningAmber};
`;

const SafetyText = styled.p`
  font-size: 12px;
  color: ${theme.colors.textSecondary};
  line-height: 1.65;
`;

export default InfoPanel;
